export const SEEN_ENTERPRISE_EXPIRATION_ALERT_COOKIE_PREFIX = 'seen-enterprise-expiration-alert-';

export const SEEN_ENTERPRISE_EXPIRATION_MODAL_COOKIE_PREFIX = 'seen-enterprise-expiration-modal-';

export const PLAN_EXPIRY_VARIANTS = {
  expired: 'Expired',
  expiring: 'Expiring',
};
